import React, { useState } from 'react'
import { Typography, Card, Row, Col } from 'antd'
import capitalize from 'lodash.capitalize'
import PropTypes from 'prop-types'
import RoadmapV2 from 'model/carePlans/carePlan'
import { Button } from 'ui/styled'
import { getOrganizationName } from 'utils/tables'
import CareEntitySection from './CareEntitySection'
import IntroductionModal from './IntroductionModal'
import { CardWithMargin } from './styled'

const { Title, Paragraph } = Typography

const SummaryStep = ({ carePlan, setLoading }) => {
  const [showIntroductionModal, setShowIntroductionModal] = useState(false)

  const {
    introduction,
    member: { id: memberId, getFullName, organization },
    performed_by
  } = carePlan

  const extraButton = (f, entity) => (
    <Button
      btntype="link"
      data-test={`edit${entity}Btn`}
      onClick={() => f(true)}
    >
      Edit
    </Button>
  )

  return (
    <Card title={<Title level={3}>Care Plan Summary</Title>}>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          {introduction && (
            <CardWithMargin
              title="Introduction"
              type="inner"
              extra={extraButton(setShowIntroductionModal, 'Introduction')}
            >
              <Paragraph>{`"${introduction}"`}</Paragraph>
            </CardWithMargin>
          )}
          <CardWithMargin title="Care" type="inner">
            <Paragraph>Performed By: {capitalize(performed_by)}</Paragraph>
          </CardWithMargin>
          <CardWithMargin title="Recipient" type="inner">
            <Paragraph>Member: {getFullName}</Paragraph>
            <Paragraph>Member ID: {memberId}</Paragraph>
            <Paragraph>
              Organization: {getOrganizationName(organization)}
            </Paragraph>
          </CardWithMargin>
        </Col>
        <Col span={16}>
          <CareEntitySection carePlan={carePlan} setLoading={setLoading} />
        </Col>
      </Row>
      {showIntroductionModal && (
        <IntroductionModal
          visible={showIntroductionModal}
          value={introduction}
          onClose={() => setShowIntroductionModal(false)}
          carePlan={carePlan}
        />
      )}
    </Card>
  )
}

SummaryStep.propTypes = {
  carePlan: PropTypes.shape(RoadmapV2.shape).isRequired,
  setLoading: PropTypes.func.isRequired
}

export default SummaryStep
